import React from 'react';
import { useState } from 'react';
import { widgetGroups } from '../../../config/common';
import SingleCard from '../../atoms/cards/SingleCard';
import { Grid, Typography, MenuItem, Select, FormControl, InputLabel, } from '@material-ui/core';

export default function WidgetSelector({ setSelectedWidget, selectedWidget, view, setTypeSelectForm }) {
    const [selectedCategory, setSelectedCategory] = useState("1");

    const displayedWidgets = 
        (selectedCategory && selectedCategory != "1") ? 
        widgetGroups.find(group => group.category === selectedCategory)?.widgets || [] :
        widgetGroups.flatMap(group => group.widgets);

    const uiWidgets = view?.view_schema?.[0]?.children?.filter(item => item.category === 'ui') || [];
    const filteredUiWidgets = []
    uiWidgets.forEach(widget => {
        if(!filteredUiWidgets?.map(item => item?.type)?.includes(widget?.type)){
            filteredUiWidgets.push(widget)
        }
    })

    const recentWidgets = filteredUiWidgets?.slice(-4).map(uiWidget => {
        const matchingWidget = widgetGroups
            .flatMap(group => group.widgets)
            .find(widget => widget.value === uiWidget.type);

        return matchingWidget || uiWidget; // Return the matching widget or the original if not found
    });


    const handleCategoryChange = (event) => {
        setSelectedCategory(event.target.value);
    };

    const onClick = (item) => {
        setSelectedWidget(item)
        setTypeSelectForm(false)
    }

    return (
        <div style={{ padding: '20px' }}>
            <Grid container spacing={3}>

                {recentWidgets.length > 0 && (
                    <>
                        <Grid item xs={12} style={{paddingLeft: 0}}>
                            <Typography variant="h6" style={{marginBottom: '10px' }}>
                                Recent Items
                            </Typography>
                        </Grid>
                        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                            {recentWidgets.map((item, index) => (
                                <Grid item xs={12} sm={6} md={3} key={index}>
                                    <SingleCard isActive={item.value === selectedWidget?.value} title={item.title} image={item.image} onClick={() => onClick(item)} />
                                </Grid>
                            ))}
                        </Grid>
                    </>
                )}

                <Grid container style={{ marginBottom: '20px', display: "flex", justifyContent: "flex-end" }}>
                    <Grid item xs={12} sm={6} md={3} style={{}}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel>Select Category</InputLabel>
                            <Select
                                value={selectedCategory}
                                onChange={handleCategoryChange}
                                label="Select Category"
                                id="widgetGroupSelector"
                            >
                                <MenuItem value="1"><em>All Widgets</em></MenuItem>
                                {widgetGroups.map((group) => (
                                    <MenuItem key={group.category} value={group.category}>
                                        {group.category}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid container spacing={3}  id="widgetGroupContainer">
                    {displayedWidgets.map((item, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <SingleCard isActive={item.value === selectedWidget?.value} title={item.title} image={item.image} onClick={() => onClick(item)} />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </div>

    )

}
